import React, { ReactElement, useContext, useMemo } from 'react';
import { FileCollectionT, ObjectContainerClientDataT, ObjectContainerClientT, ObjectTypeClientT } from 'bovaljaren-models';
import { Card, CardMedia, CardContent, Grid, IconButton } from '@material-ui/core';
import './FavoriteItem.scss';
import { formatValue } from '../../../../utils/object.helper';
import { AppContext } from '../../../../state/app.state';
import { Close } from '@material-ui/icons';

type Props = {
    object: ObjectContainerClientT;
    typeName: string | undefined;
    fileCollections?: FileCollectionT[];
    onRemoveButtonClick?: (objectId: number) => void;
    onReadMoreClick?: (objectId: number) => void;
};

//Exposing parts of the properties that should be available when using FavoriteList as an component.
export type FavoriteItemActionsT = {
    onRemoveButtonClick?: (objectId: number) => void;
    onReadMoreClick?: (objectId: number) => void;
};

const FavoriteItem: React.FC<Props> = ({ typeName, object, fileCollections, onRemoveButtonClick, onReadMoreClick }): ReactElement => {
    const { state, presentationState, favoriteState } = useContext(AppContext);
    const status = useMemo(() => state?.project?.statuses.find(s => s.id === object.statusId), [object.statusId, state?.project?.statuses]);


    return (
        <Grid item xs={12} >
            <Card data-testid='favorite-item' variant="outlined"
                onMouseOver={():void => {
                    state?.setPreviewObjectId(object.id);
                }}
                onMouseOut={():void => {
                    state?.setPreviewObjectId(undefined);
                }}
                className={'bv-favorite-list-item'}>
                <CardContent className={'bv-favorite-list-item-content'}>
                    {status && <div className={`bv-favorite-item-title bv-${status?.type}`}
                        onClick={(): void => {
                            onReadMoreClick && onReadMoreClick(object.id);
                        }}>
                        <span className="bv-mapping-facts-label-content-row-name  bv-mapping-facts-label-content-row-name--status bv-favorite-item-title-text">{typeName} {object.name}</span>
                        <span className="bv-mapping-facts-label-content-row-value  bv-mapping-facts-label-content-row-value--status"></span>
                    </div>}
                    <div className='bv-favorite-list-content-lower'>
                        <div className='bv-favorite-list-item-data'
                            onClick={(): void => {
                                onReadMoreClick && onReadMoreClick(object.id);
                            }}>{object.data?.filter(d => d.value !== null && d.value !== '' && d.type !== 'description' && d.type !== 'externalUrl' && d.type !== 'richDescription' && d.name !== '' && d.name !== null && !!d.name).map((d, index) => {
                                return <div key={index}><b>{d.name}</b> {formatValue(d, d.type)} {d.ending}</div>;
                            })}</div>
                        <IconButton className='bv-favorite-list-item-close' onClick={(): void => favoriteState?.removeFavorite(object.id)}><Close/></IconButton>
                    </div>
                </CardContent>
            </Card>
        </Grid>
    );
};


export default FavoriteItem;